import React, {useState, useEffect} from "react";
import { Bot } from 'lucide-react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import API from "../../../../utils/API";
import {
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    Container,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";
import classnames from "classnames";
import AiEditor from "./AiEditor";
import {SameIntegration} from "./SameIntegration";
import SendFormatEditLog from "./SendFormatEditLog";

const SendFormatChanger = ({orderId}) => {
    const [openModal, setOpenModal] = useState(false);
    const [sameSendFormatList, setSameSendFormatList] = useState([]);
    const [activeTab, setActiveTab] = useState("editor");
    const [editLog, setEditLog] = useState([]);
    const [reload, setReload] = useState(false);

    const toggleReload = () => {
        setReload(!reload);
    }

    useEffect(()=>{
        if (openModal) {
            API.get(`/admin/order/sendformat/sameintegration/${orderId}`).then((response) => {
                setSameSendFormatList(response.data.data);
            });
            API.post(`/ai/integration/editlog`, {orderId}).then((response) => {
                setEditLog(response.data.data);
            });
        }
    },[orderId, openModal])

    return <>
        <button className="btn btn-primary mt-2" onClick={() => setOpenModal(true)}>
            <Bot size={18} color="white" /> Edit send format
        </button>
    <Modal
        isOpen={openModal}
        toggle={() => setOpenModal(false)}
        size="lg"
        style={{maxWidth: '1600px', width: '90%'}}
    >
        <ModalHeader toggle={() => setOpenModal(false)}>Edit send format</ModalHeader>
        <ModalBody style={{backgroundColor:"#F7F9FC"}}>
            <div className={"tab default"}>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "editor" })}
                            onClick={() => {
                                setActiveTab("editor");
                            }}
                        >
                            AI Editor
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({
                                active: activeTab === "orders",
                            })}
                            onClick={() => {
                                setActiveTab("orders");
                            }}
                        >
                            Orders with the same send format{" "}
                            <Badge color="primary">{sameSendFormatList.length}</Badge>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "editLog" })}
                            onClick={() => {
                                setActiveTab("editLog");
                            }}
                        >
                            Edit log{" "}
                            {editLog.length > 0 && <Badge color="primary">{editLog.length}</Badge>}
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="editor">
                        <AiEditor orderId={orderId}/>
                    </TabPane>
                    <TabPane tabId="orders">
                        <SameIntegration integrations={sameSendFormatList} orderId={orderId}/>
                    </TabPane>
                    <TabPane tabId="editLog">
                        <SendFormatEditLog editLog={editLog}/>
                    </TabPane>
                </TabContent>
            </div>
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={() => setOpenModal(false)}>Close</Button>
        </ModalFooter>
    </Modal></>;
}

export default SendFormatChanger;
